<template>
    <div>
        <h1>Id Persona relacionada: {{ $route.params.persona.name }} </h1>     
        <v-toolbar dark flat color="grey-lighten">
            <v-toolbar-title>Bloques relacionados con personas</v-toolbar-title>
                <v-divider class="mx-2" inset vertical ></v-divider>
                <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-title>
            <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar..."
                single-line
                hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="tableData"
            :search="search"
            class="elevation-1"  
            v-if="tableData.length"     
        >
            <template slot="items" slot-scope="props">
                <td>{{ props.item.nombre }}</td>   
                <td>
                    <router-link class="justify-center" :to="{ name: 'respuestas', params: {persona : props.item} }">
                        <v-btn class="ma-2" color="primary" dark>
                            <v-icon>visibility</v-icon>
                         </v-btn>
                      </router-link>    
                </td>
            </template>
            <template slot="no-data">
                <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>     
        </v-data-table>
    </div>
</template>
<script>
import Preguntas from "../../services/Preguntas";
import Bloques from "../../services/Bloques";
import Traslado from "../../services/Traslado";  
import VictimasRepresentante from "../../services/VictimasRepresentante";  
import Auth from "../../Auth";

  export default {
  data: () => ({
      mostrar: false,
        usuario: {},
        bloques: [],
        search: '',
        headers: [
            {text: 'Nombre del Bloque', value: 'nombre'},
            {text: 'Acciones', value: 'name', sortable: false},
        ],
        boton_guardar:true,
        tableData: [],
        tableDataFiles: [],
        editedIndex: -1,
        editedItem: {
            id: '',
            nombre: '',
            created_at: '',
        },
        defaultItem: {
            id: '',
            nombre: '',
            created_at: '',
        }
  }),
  mounted(){
        this.usuario = { ...user };  
        var idPersona = this.$route.params.persona.id;          
        console.log(idPersona)
        Bloques.getBloquesIdUsuario(idPersona).then(response => {
           console.log(response)
           this.tableData = response.data;   
           console.log(this.tableData.length)         
        });
  },
  created() {
      console.log('created')
    this.initialize();
  },
   methods: {
      initialize() {
          console.log('initialize')
        console.log(this.usuario);
      }
    }
  }
</script>  